import React, { useContext, useState } from 'react'
import { Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import InputText from '../../../DevComponents/InputText'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal'
import Condicional from '../../../Layout/Condicional'
import Button from '@mui/material/Button'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'

import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable'
import { useNavigate } from 'react-router-dom'
import { AmostraReferenciaInterface } from '../../../ImportBackend/Interfaces/AmostraReferenciaInterface'
import ClsCrud, { StatusForm } from '../../../Utils/ClsCrud'

import ClsValidacao from '../../../Utils/ClsValidacao'
import { EMDESENVOLVIMENTO } from '../../../ImportBackend/Config/emDesenvolvimento'
import PesquisarTabela from '../../../DevComponents/PesquisarTabela'
import { MaterialInterface } from '../../../ImportBackend/Interfaces/MaterialInterfaces'
import ClsFormatacao from '../../../Utils/ClsFormatacao'
import AmostraReferenciaDeterminacoes from './AmostraReferenciaDeterminacoes'

interface PesquisaInterface {
  descricao: string
}

export default function AmostrasReferencia() {

  const [statusForm, setStatusForm] = useState<StatusForm>(StatusForm.Pesquisando)

  const clsFormatos: ClsFormatacao = new ClsFormatacao()

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'descricao',
      cabecalho: 'Descrição',
      alinhamento: 'left'
    },
    {
      campo: 'Material',
      cabecalho: 'Material',
      alinhamento: 'left',
      format: (v: MaterialInterface) => v.descricao
    },
    {
      campo: 'data',
      cabecalho: 'Data',
      alinhamento: 'left',
      format: (data: string) => clsFormatos.dataISOtoUser(data)
    },
    {
      campo: 'ativo',
      cabecalho: 'Ativo',
      alinhamento: 'left',
      format: (v: boolean) => { return v ? 'Sim' : 'Não' }
    }
  ]

  const ResetDados: AmostraReferenciaInterface = {
    idAmostraReferencia: 0,
    idMaterial: 0,
    data: '',
    descricao: '',
    ativo: false
  }

  const TituloForm = {
    [StatusForm.Incluindo]: 'Inclusão de Nova Amostra de Referência',
    [StatusForm.Excluindo]: 'Exclusão de Amostra de Referência Não Utilizada',
    [StatusForm.Pesquisando]: 'Amostras de Referência',
    [StatusForm.Editando]: 'Alteração de Dados de Amostra de Referência',
    [StatusForm.Exibindo]: 'Dados da Amostra de Referência'
  }

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const [dados, setDados] = useState<AmostraReferenciaInterface>(ResetDados)

  const [erros, setErros] = useState({})

  const [pesquisa, setPesquisa] = useState<PesquisaInterface>({ descricao: '' })

  const [rsPesquisa, setRsPesquisa] = useState<Array<AmostraReferenciaInterface>>([])

  const navigate = useNavigate()

  const validarDados = (): boolean => {
    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.naoVazio('descricao', dados, erros, retorno)
    retorno = clsValidacao.naoVazio('idMaterial', dados, erros, retorno)
    retorno = clsValidacao.naoVazio('data', dados, erros, retorno)

    setErros(erros)

    return retorno
  }

  const clsCrud: ClsCrud<AmostraReferenciaInterface> = new ClsCrud(
    navigate,
    ResetDados,
    setStatusForm,
    setDados,
    setErros,
    mensagemState,
    setMensagemState,
    setRsPesquisa,
    contexto,
    validarDados,
    {
      confirmarMutation: 'updateAmostraReferencia',
      excluirMutation: 'delAmostraReferencia',
      campoId: 'idAmostraReferencia',
      camposPesquisa: '{ idAmostraReferencia idMaterial descricao data ativo Material { idMaterial, descricao } }',
      pesquisaQuery: 'getAmostrasReferencia',
      pesquisaPorId: 'getAmostraReferenciaPorId',
      camposPesquisaPorId: '{ idAmostraReferencia idMaterial descricao data ativo }'
    },

    {
      confirmando: 'Atualizando Amostra de Referência',
      erroCadastro: 'Erro ao Cadastrar Amostra de Referência',
      erroExclusao: 'Erro ao Excluir Amostra de Referência',
      erroPesquisa: 'Erro ao Pesquisar Amostra de Referência',
      pesquisando: 'Pesquisando Dados de Amostras de Referência...',
      sucessoCadastro: 'Amostra de Referência Cadastrada com sucesso!',
      atualizacaoSucesso: 'Amostra de Referência Atualizada com sucesso!',
      tituloConfirmado: 'Confirmado!',
      sucessoExclusao: 'Amostra de Referência Excluída com sucesso...',
      tituloConfirmacaoExclusao: 'Confirma?',
      tituloErroCadastro: 'Erro!',
      tituloErroExclusao: 'Erro!',
      tituloErroPesquisa: 'Erro!',
      excluindo: 'Excluindo Amostra de Referência...'
    }
  )

  const onKeyPesquisa = () => {
    clsCrud.onClickPesquisa(pesquisa.descricao, mensagemState)
  }

  const btEditarDeterminacoesAmostraReferencia = (dados: AmostraReferenciaInterface) => {
    setDados(dados)
    setStatusForm(StatusForm.Exibindo)
  }

  return (
    <>
      <Container maxWidth="md" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Cadastro de Amostras de Referência
                <Typography variant="body2" gutterBottom>
                  {TituloForm[statusForm]}
                </Typography>
              </Typography>

              <IconButton onClick={() => clsCrud.btFechar()}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Condicional condicao={statusForm === StatusForm.Pesquisando}>

              <Grid item xs={12} sm={10} sx={{ mb: 3 }}>

                <InputText
                  dados={pesquisa}
                  field='descricao'
                  label='Pesquisar'
                  setState={setPesquisa}
                  iconeEnd="search"
                  onClickIconeEnd={() => clsCrud.onClickPesquisa(pesquisa.descricao, mensagemState)}
                  mapKeyPress={[{ key: 'Enter', onKey: onKeyPesquisa }]}
                />

              </Grid>

              <Grid item xs={12} sm={2} alignSelf='center' sx={{ mt: { xs: 0, sm: 2 }, textAlign: { xs: 'right', sm: 'center' } }}>
                <Button variant='contained' onClick={() => clsCrud.btIncluir()}>Incluir</Button>
              </Grid>

            </Condicional>

            <Condicional condicao={statusForm !== StatusForm.Pesquisando}>

              <Grid item xs={12}>
                <InputText
                  dados={dados}
                  field='descricao'
                  label='Descrição'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo || statusForm === StatusForm.Exibindo}
                  erros={erros}
                  maxLength={50}
                />
              </Grid>

              <Grid item xs={6}>
                <PesquisarTabela<MaterialInterface>
                  setState={setDados}
                  field='idMaterial'
                  fieldSet='idMaterial'
                  label='Material'
                  dados={dados}
                  campoQueryPesquisaID='idMaterial'
                  campoQueryPesquisa='pesquisa'
                  camposRetornoQueryPesquisa='{idMaterial, descricao}'
                  campoLabelQueryPesquisa='descricao'
                  nomeQueryPesquisa='getMateriais'
                  nomeQueryPesquisaID='getMaterialPorId'
                  mensagemPesquisa='Procurando Materiais...'
                  disabled={statusForm === StatusForm.Excluindo || statusForm === StatusForm.Exibindo}
                  erros={erros}
                  pesquisarTudoAoIniciar
                />
              </Grid>

              <Grid item xs={6} sx={{ pl: 2 }}>
                <InputText
                  dados={dados}
                  field='data'
                  label='Data'
                  setState={setDados}
                  tipo='date'
                  disabled={statusForm === StatusForm.Excluindo || statusForm === StatusForm.Exibindo}
                  erros={erros}
                />
              </Grid>

              <Grid item xs={6} sx={{ mt: 1 }}>
                <InputText
                  dados={dados}
                  field='ativo'
                  label='Ativo'
                  setState={setDados}
                  tipo='checkbox'
                  disabled={statusForm === StatusForm.Excluindo || statusForm === StatusForm.Exibindo}
                  erros={erros}
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 3 }}>
                <Condicional condicao={statusForm === StatusForm.Exibindo}>
                  <AmostraReferenciaDeterminacoes
                    idMaterial={dados.idMaterial}
                    idAmostraReferencia={dados.idAmostraReferencia as number}
                  />
                </Condicional>
              </Grid>

              <Grid item xs={12} sx={{ mt: 3 }}>

                <Condicional condicao={statusForm === StatusForm.Excluindo}>
                  <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => clsCrud.btConfirmarExclusao(dados, mensagemState, pesquisa.descricao)}>Confirmar</Button>
                </Condicional>

                <Condicional condicao={statusForm !== StatusForm.Excluindo && statusForm !== StatusForm.Exibindo}>
                  <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => clsCrud.btConfirmar(dados, mensagemState, statusForm, pesquisa.descricao)}>Confirmar</Button>
                </Condicional>

                <Condicional condicao={statusForm !== StatusForm.Exibindo}>
                  <Button variant='contained' startIcon={<CloseIcon />} sx={{ py: 1 }} onClick={() => clsCrud.btCancelar()}>Cancelar</Button>
                </Condicional>

                <Condicional condicao={statusForm === StatusForm.Exibindo}>
                  <Button variant='contained' startIcon={<CloseIcon />} sx={{ py: 1 }} onClick={() => clsCrud.btCancelar()}>Retornar</Button>
                </Condicional>

              </Grid>

            </Condicional>

            <Condicional condicao={statusForm === StatusForm.Pesquisando}>
              <Grid item xs={12} sx={{ mt: 3 }}>
                <DataTable dados={rsPesquisa} cabecalho={Cabecalho} acoes={[

                  { icone: 'delete', toolTip: 'Excluir', onAcionador: clsCrud.btExcluir },
                  { icone: 'create', toolTip: 'Alterar', onAcionador: clsCrud.btEditar },
                  { icone: 'science', toolTip: 'Padrão', onAcionador: btEditarDeterminacoesAmostraReferencia }
                ]} />
              </Grid>
            </Condicional>

            <Condicional condicao={EMDESENVOLVIMENTO}>
              {JSON.stringify(dados)}
              {JSON.stringify(erros)}
            </Condicional>

          </Grid>
        </Paper>

      </Container>
    </>
  )
}
